const BULK_DOWNLOAD_DEVICE = "device:bulk::download";
const BULK_DOWNLOAD_DEVICE_CUSTOM = "device:bulk::download::custom";
const BULK_EDIT_DEVICE = "device::bulk::edit";
const BULK_EDIT_DEVICE_SUCCESS = "device::bulk::edit::success";
const BULK_NEW_DEVICE = "device::bulk::new";
const BULK_NEW_DEVICE_SUCCESS = "device::bulk::new::success";
const CLEAR_CACHE = "device::clear::cache";
const CLEAR_WEBCAM_SNAPSHOT_CACHE = "device::clear::webcam-snapshot-cache";
const DELETE_DEVICES = "device::delete";
const DELETE_DEVICES_SUCCESS = "device::delete::success";
const EDIT_DEVICE = "device::edit";
const EDIT_DEVICE_SUCCESS = "device::edit::success";
const EDIT_DEVICE_FLAGS = "device::edit-flags";
const EDIT_DEVICE_FLAGS_SUCCESS = "device::edit-flags::success";
const EDIT_DEVICE_PARAMS = "device::edit-params";
const EDIT_DEVICE_PARAMS_SUCCESS = "device::edit-params::success";
const GET_INTERNAL_STATE_DEVICE = "device::get::internal-state";
const GET_LOGS_DEVICE = "device::get::logs";
const GET_PLAYER_UPDATE_VERSIONS = "device::get::player-update-versions";
const GET_PLAYER_UPDATE_VERSIONS_SUCCESS =
  "device::get::player-update-versions::success";
const GET_PLAYER_UPDATE_VERSIONS_FAILURE =
  "device::get::player-update-versions::failure";
const LOAD_DEVICES = "device::load-devices";
const LOAD_DEVICES_FAILURE = "device::load-devices::failure";
const LOAD_DEVICES_SUCCESS = "device::load-devices::success";
const NEW_DEVICE = "device::new";
const NEW_DEVICE_SUCCESS = "device::new::success";
const RESTART_DEVICE = "device::restart";
const TAKE_SCREEN_SHOT_DEVICE = "device::take::screen-shot";
const TAKE_WEBCAM_SNAPSHOT_DEVICE = "device::take::snap-shot";
const UPGRADE_DEVICES = "device::upgrade";
const UPGRADE_DEVICES_SUCCESS = "device::upgrade::success";
const UPGRADE_DEVICES_FIRMWARE = "device::upgrade-firmware";
const UPGRADE_DEVICES_FIRMWARE_SUCCESS = "device::upgrade-firmware::success";
const DOWNGRADE_DEVICES = "device::downgrade";
const DOWNGRADE_DEVICES_SUCCESS = "device::downgrade::success";
const CANCEL_UPGRADE = "device::cancel-upgrade";
const CANCEL_UPGRADE_SUCCESS = "device::cancel-upgrade::success"

function loadDevicesAction(payload) {
  return {
    payload,
    type: LOAD_DEVICES,
  };
}

function newDeviceAction(options) {
  const { serviceArgs, successMessage, resolve, reject } = options;
  const {
    deviceName,
    isAgent,
    location,
    networkId,
    partnerVenueId,
    registrationCode,
    tags,
  } = serviceArgs;

  return {
    payload: {
      successMessage,
      serviceArgs: [
        registrationCode,
        deviceName,
        networkId,
        tags,
        partnerVenueId,
        location,
        isAgent,
      ],
      resolve,
      reject,
    },
    type: NEW_DEVICE,
  };
}

function bulkNewDeviceAction(options) {
  const { serviceArgs, successMessage, resolve, reject } = options;
  const { file } = serviceArgs;

  return {
    payload: {
      successMessage,
      serviceArgs: [file],
      resolve,
      reject,
    },
    type: BULK_NEW_DEVICE,
  };
}

function bulkEditDeviceAction(options) {
  const { serviceArgs, successMessage, resolve, reject } = options;
  const { file } = serviceArgs;

  return {
    payload: {
      successMessage,
      serviceArgs: [file],
      resolve,
      reject,
    },
    type: BULK_EDIT_DEVICE,
  };
}

export {
  BULK_DOWNLOAD_DEVICE,
  BULK_DOWNLOAD_DEVICE_CUSTOM,
  BULK_EDIT_DEVICE,
  BULK_EDIT_DEVICE_SUCCESS,
  BULK_NEW_DEVICE,
  BULK_NEW_DEVICE_SUCCESS,
  bulkEditDeviceAction,
  bulkNewDeviceAction,
  CLEAR_CACHE,
  CLEAR_WEBCAM_SNAPSHOT_CACHE,
  DELETE_DEVICES,
  DELETE_DEVICES_SUCCESS,
  EDIT_DEVICE,
  EDIT_DEVICE_FLAGS,
  EDIT_DEVICE_FLAGS_SUCCESS,
  EDIT_DEVICE_PARAMS,
  EDIT_DEVICE_PARAMS_SUCCESS,
  EDIT_DEVICE_SUCCESS,
  GET_INTERNAL_STATE_DEVICE,
  GET_LOGS_DEVICE,
  GET_PLAYER_UPDATE_VERSIONS,
  GET_PLAYER_UPDATE_VERSIONS_SUCCESS,
  GET_PLAYER_UPDATE_VERSIONS_FAILURE,
  LOAD_DEVICES,
  LOAD_DEVICES_FAILURE,
  LOAD_DEVICES_SUCCESS,
  loadDevicesAction,
  NEW_DEVICE,
  NEW_DEVICE_SUCCESS,
  newDeviceAction,
  RESTART_DEVICE,
  TAKE_SCREEN_SHOT_DEVICE,
  TAKE_WEBCAM_SNAPSHOT_DEVICE,
  UPGRADE_DEVICES,
  UPGRADE_DEVICES_FIRMWARE,
  UPGRADE_DEVICES_FIRMWARE_SUCCESS,
  UPGRADE_DEVICES_SUCCESS,
  DOWNGRADE_DEVICES,
  DOWNGRADE_DEVICES_SUCCESS,
  CANCEL_UPGRADE,
  CANCEL_UPGRADE_SUCCESS,
};
